export const state = function () {
  return {
    acceptablePayinOrigins: ["sendtrack", "unitary_pack", "pack"],
    processing_payment: false,
    current_og: "",
    unitary_pack_cost: 0,
  }
}

export const mutations = {
  SET_CURRENT_ORIGIN(state, new_origin) {
    state.current_og = new_origin
  },
  SET_PROCESSING_STATUS(state, boolean) {
    state.processing_payment = boolean
  },
  SET_UNITARY_PACK_COST(state, amount) {
    state.unitary_pack_cost = Number(amount)
  },
}

export const actions = {
  PAY({ state, dispatch, commit, getters }) {
    return new Promise(async (resolve, reject) => {
      const type = state.payment_method.selected
      var returnValue

      commit("SET_PROCESSING_STATUS", true)
      if (type === "card")
        returnValue = await dispatch("payment_method/mangopay/PAY")
      if (getters["PURCHASE_TYPE"] === "sendtrack" && !returnValue)
        await dispatch("VALIDATE_TRANSACTION", { invoice: true })
      resolve(returnValue)
    })
  },
  CREATE_CAMPAIGN: async function (_, { draft, invoice }) {
    return new Promise((resolve, reject) => {
      this.$axios
        .$post(
          "/submission/campaign/",
          {
            draft,
            invoice,
          },
          {
            headers: { "X-CSRFToken": this.$cookies.get("csrftoken") },
          }
        )
        .then((response) => {
          resolve(response)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  VALIDATE_TRANSACTION(
    { commit, dispatch, rootState },
    { draft, invoice = false } = {}
  ) {
    return new Promise((resolve, reject) => {
      commit("SET_PROCESSING_STATUS", true)
      dispatch("CREATE_CAMPAIGN", {
        draft: draft || rootState.draft.id,
        invoice,
      })
        .then((response) => {
          commit("user/SET_GROOVIZ", parseFloat(response.groovies), {
            root: true,
          })
          resolve(response)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
}

export const getters = {
  CAN_PAY(state, getters) {
    if (!state.processing_payment) {
      const type = state.payment_method.selected

      if (type === "paypal")
        return getters["payment_method/paypal/READY_TO_CONFIRM"]
      else if (
        type === "card" &&
        state.payment_method.mangopay.selected_card_id
      )
        return true
      else return false
    } else return false
  },
  PURCHASE_TYPE(state, getters, rootState, rootGetters) {
    const has_valid_purchase_type =
      state.acceptablePayinOrigins.indexOf(state.current_og) !== -1
    const requirements = {
      sendtrack: rootGetters["user/IS_BAND"],
      unitary_pack:
        state.unitary_pack_cost >= 10 && state.unitary_pack_cost <= 10000,
      pack: true,
    }

    if (has_valid_purchase_type && requirements[state.current_og] !== false)
      return state.current_og
    else return false
  },
  MISSING_CREDITS(state, getters, rootState, rootGetters) {
    const type = getters["PURCHASE_TYPE"]
    if (type === "sendtrack") return rootGetters["draft/pricing/MISSING"]
    if (type === "unitary_pack") return state.unitary_pack_cost
    if (type === "pack") return getters["packs/SELECTED_PACK_OBJ"].cost
    else return 0
  },
  PURCHASE_AMOUNT(state, getters, rootState, rootGetters) {
    const type = getters["PURCHASE_TYPE"]

    if (type === "sendtrack")
      return rootGetters["draft/pricing/ADJUSTED_MISSING"]
    if (type === "unitary_pack") return state.unitary_pack_cost
    if (type === "pack" && getters["packs/IS_SELECTED"]) return 0
    return 0
  },
  FINAL_PURCHASE_AMOUNT(state, getters) {
    if (!getters["packs/IS_SELECTED"]) return getters["PURCHASE_AMOUNT"]
    else return getters["packs/SELECTED_PACK_OBJ"].cost
  },
  FINAL_CREDITS_PURCHASE_AMOUNT(_state, getters, _rootState, rootGetters) {
    if (getters["packs/IS_SELECTED"])
      return getters["packs/SELECTED_PACK_OBJ"].groovies
    if (getters["PURCHASE_TYPE"] === "sendtrack")
      return rootGetters["draft/pricing/ADJUSTED_MISSING"]
    else return getters["MISSING_CREDITS"]
  },
  STANDARD_EVENT_DATA(state, getters, rootState) {
    return {
      currency: "EUR",
      value: getters["FINAL_PURCHASE_AMOUNT"],
      content_ids: [getters["PURCHASE_TYPE"]],
      content_type: "product",
      first_payment: rootState.user.first_payment_date,
      is_pack: getters["packs/IS_SELECTED"],
      pack_name: getters["packs/IS_SELECTED"]
        ? getters["packs/SELECTED_PACK_OBJ"].name
        : undefined,
      is_shop: false,
    }
  },
  LOOSE_EVENT_DATA(state, getters, rootState) {
    return {
      $revenue: getters["FINAL_PURCHASE_AMOUNT"],
      type: getters["PURCHASE_TYPE"],
      first_payment: rootState.user.first_payment_date,
      is_pack: getters["packs/IS_SELECTED"],
      pack_name: getters["packs/IS_SELECTED"]
        ? getters["packs/SELECTED_PACK_OBJ"].name
        : undefined,
    }
  },
}
